import { Link } from "react-router-dom";
import { Container } from "@/components/ui-hf";
import { BDV_CONTACT } from "@/lib/homeContent";

export default function HFFooter() {
    return (
        <footer
            data-testid="site-footer"
            className="border-t border-hf-line"
            style={{ background: "hsl(var(--hf-surface))" }}
        >
            <Container className="py-14 md:py-20 grid grid-cols-1 md:grid-cols-4 gap-10">
                <div className="md:col-span-1">
                    <Link
                        to="/"
                        className="flex items-center gap-3"
                        data-testid="site-footer-logo"
                    >
                        <img
                            src="/hypefly-badge.png"
                            alt="HypeFly – 3D-Logo mit Drohne"
                            className="shrink-0 w-12 h-12 object-contain"
                            style={{ borderRadius: "3px" }}
                            data-testid="site-footer-logo-mark"
                        />
                        <span className="flex flex-col leading-none">
                            <span
                                className="font-display font-semibold text-[22px]"
                                style={{ color: "#1D1B18", letterSpacing: "-0.01em", lineHeight: 1 }}
                                data-testid="site-footer-logo-name"
                            >
                                HypeFly
                            </span>
                            <span
                                className="flex flex-col mt-1"
                                style={{
                                    color: "#A78150",
                                    fontFamily: "Jost, sans-serif",
                                    fontSize: "9px",
                                    fontWeight: 500,
                                    letterSpacing: "0.22em",
                                    textTransform: "uppercase",
                                    lineHeight: 1.15,
                                }}
                                data-testid="site-footer-logo-tagline"
                            >
                                <span>Premium</span>
                                <span>360°</span>
                            </span>
                        </span>
                    </Link>
                    <p className="mt-5 text-sm text-hf-muted leading-relaxed max-w-xs">
                        Ein digitales Gedächtnis Ihrer Immobilie. Ruhig,
                        respektvoll, gründlich.
                    </p>
                </div>

                <div>
                    <div className="hf-eyebrow">Marke</div>
                    <div className="mt-4 text-sm text-hf-ink leading-relaxed">
                        {BDV_CONTACT.brand}
                        <br />
                        <span className="text-hf-muted">
                            {BDV_CONTACT.street}
                            <br />
                            {BDV_CONTACT.zip} {BDV_CONTACT.city}
                        </span>
                    </div>
                </div>

                <div>
                    <div className="hf-eyebrow">Rechtliches</div>
                    <ul className="mt-4 text-sm space-y-2">
                        <li>
                            <Link
                                to="/impressum"
                                className="text-hf-ink hover:text-hf-gold-dark transition-colors"
                                data-testid="site-footer-impressum"
                            >
                                Impressum
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/datenschutz"
                                className="text-hf-ink hover:text-hf-gold-dark transition-colors"
                                data-testid="site-footer-datenschutz"
                            >
                                Datenschutz
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/bdv-kontakt"
                                className="text-hf-ink hover:text-hf-gold-dark transition-colors"
                                data-testid="site-footer-bdv-kontakt"
                            >
                                Kontakt (BDV GmbH)
                            </Link>
                        </li>
                    </ul>
                </div>

                <div>
                    <div className="hf-eyebrow">Kontakt</div>
                    <ul className="mt-4 text-sm space-y-2">
                        <li>
                            <a
                                href={`tel:${BDV_CONTACT.phoneHref}`}
                                className="text-hf-ink hover:text-hf-gold-dark transition-colors"
                                data-testid="site-footer-phone"
                            >
                                {BDV_CONTACT.phone}
                            </a>
                        </li>
                        <li>
                            <a
                                href={`mailto:${BDV_CONTACT.email}`}
                                className="text-hf-ink hover:text-hf-gold-dark transition-colors"
                                data-testid="site-footer-email"
                            >
                                {BDV_CONTACT.email}
                            </a>
                        </li>
                    </ul>
                </div>
            </Container>
            <div
                className="border-t border-hf-line"
                style={{ background: "hsl(var(--hf-surface-2) / 0.5)" }}
            >
                <Container className="py-5 text-xs text-hf-muted flex flex-col md:flex-row items-center justify-between gap-3">
                    <div>
                        © {new Date().getFullYear()} {BDV_CONTACT.company}. Alle Rechte vorbehalten.
                    </div>
                    <nav
                        aria-label="Kurz-Navigation"
                        className="flex flex-wrap items-center gap-x-4 gap-y-1"
                        data-testid="site-footer-mininav"
                    >
                        <Link
                            to="/#faq"
                            className="text-hf-muted hover:text-hf-gold-dark transition-colors"
                            data-testid="site-footer-faq"
                        >
                            FAQ
                        </Link>
                        <span aria-hidden className="text-hf-line">·</span>
                        <Link
                            to="/#kontakt"
                            className="text-hf-muted hover:text-hf-gold-dark transition-colors"
                            data-testid="site-footer-kontakt-anchor"
                        >
                            Kontakt
                        </Link>
                        <span aria-hidden className="text-hf-line">·</span>
                        <span>HypeFly · Premium-360°-Immobiliendokumentation</span>
                    </nav>
                </Container>
            </div>
        </footer>
    );
}
